import ValidationRule from './ValidationRule';

import { isValidPhoneNumber } from 'react-phone-number-input';

class PhoneNumberValidationRule extends ValidationRule {
  validate(val) {
    return isValidPhoneNumber(val);
  }
}

export default PhoneNumberValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/PhoneNumberValidationRule.js